import CONSTANTS from 'core/data-model/constants/values'
import { getPartnerAvailableDisplayProduct } from 'quick-quote/selectors/partner-selector'
import { store as qqStore } from 'store'

/**
 * createProductBumnanReadyService
 */
export function createProductBumnanReadyService() {
  function getSelectableProductBumnanReady(_state) {
    const availableDisplayProducts = getPartnerAvailableDisplayProduct(qqStore.getState())
    return CONSTANTS.BUMNAN_READY_CODE_GROUP.filter((code) => availableDisplayProducts[code][0])
  }

  return {
    getSelectableProductBumnanReady,
  }
}
